/**
 * Middleware Checking Modal History State
 *
 *    - <ui-modal> adds an "#modal" to the history state
 *    - but if the user reload its page, the flag will remains → this
 *      middleware will check and reject such case (without altering the
 *      history)
 *    - applyied once at startup
 *
 *  (!) unpure, mutations implies on `Vue.$route`
 */
import Console from '~/utils/lib/core/console'
import { not, test } from '~/utils/lib/core/prelude'

const console = new Console('middleware:modal-history')

let hasBeenExecuted = false

export default defineNuxtRouteMiddleware((to) => {

  if (hasBeenExecuted)
    return

  hasBeenExecuted = true

  const hasStateFlag = test(/modal/g, to.hash)

  if (not(hasStateFlag))
    return

  console.log(
    `capture trailing browser history with modal flag,`,
    `will be removed without altering browser history`
  )

  return navigateTo({ hash: undefined })
})
